// app/javascript/src/utils/recaptcha.ts
declare global {
  interface Window {
    grecaptcha?: {
      ready(callback: () => void): void;
      execute(siteKey: string, options: { action: string }): Promise<string>;
    };
  }
}

export function getSiteKey(): string {
  const tag = document.querySelector<HTMLMetaElement>('meta[name="recaptcha-site-key"]');
  if (!tag?.content) throw new Error("reCAPTCHA site key meta not found");
  return tag.content;
}

/**
 * reCAPTCHAスクリプトをロード
 */
export async function ensureRecaptchaLoaded(): Promise<void> {
  const siteKey = getSiteKey();
  const id = "recaptcha-script";

  await new Promise<void>((resolve) => {
    const existing = document.getElementById(id) as HTMLScriptElement | null;

    if (existing) {
      // スクリプトは存在するが、まだロードが完了していない場合 (grecaptchaオブジェクトがない)
      // は、loadイベントを待つ
      if (typeof window.grecaptcha !== "undefined") {
        resolve();
      } else {
        const handleLoad = () => {
          resolve();
          existing.removeEventListener("load", handleLoad);
        };
        existing.addEventListener("load", handleLoad);
      }
      return;
    }

    const s = document.createElement("script");
    s.id = id;
    s.async = true;
    s.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    s.onload = () => {
      resolve();
    };
    document.head.appendChild(s);
  });
}

/**
 * reCAPTCHA v3 のトークンを取得
 * @param action - 送信アクション名（例: "simulator_submit"）
 */
export async function getRecaptchaToken(action: string): Promise<string> {
  await ensureRecaptchaLoaded();

  if (!window.grecaptcha) throw new Error("grecaptcha not loaded");

  await new Promise<void>((resolve) => window.grecaptcha!.ready(resolve));

  return window.grecaptcha!.execute(getSiteKey(), { action });
}
